import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, ResourceRequestMethod, IResourceMethod } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';
// Import RxJs required methods

@Injectable()
@ResourceParams({
    url: `${environment.url.api}`,
    pathPrefix: '/api'
})
export class ContactService extends RestClient {
    @ResourceAction({
        path: '/contact',
        method: ResourceRequestMethod.Post,
        noAuth: true
    })
    sendContact: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/captcha-site-key',
        noAuth: true
    })
    getCaptchaKey: IResourceMethod<any, any>;
}
